/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetRegisterDto } from './GetRegisterDto';
import {
    GetRegisterDtoFromJSON,
    GetRegisterDtoFromJSONTyped,
    GetRegisterDtoToJSON,
} from './GetRegisterDto';
import type { GetHealthcareFacilityDto } from './GetHealthcareFacilityDto';
import {
    GetHealthcareFacilityDtoFromJSON,
    GetHealthcareFacilityDtoFromJSONTyped,
    GetHealthcareFacilityDtoToJSON,
} from './GetHealthcareFacilityDto';

/**
 * 
 * @export
 * @interface GetRegisterNumberingDto
 */
export interface GetRegisterNumberingDto {
    /**
     * 
     * @type {string}
     * @memberof GetRegisterNumberingDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetRegisterNumberingDto
     */
    symbolDoctor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetRegisterNumberingDto
     */
    symbolPsychological?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetRegisterNumberingDto
     */
    activeFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetRegisterNumberingDto
     */
    activeTo?: Date | null;
    /**
     * 
     * @type {GetRegisterDto}
     * @memberof GetRegisterNumberingDto
     */
    register?: GetRegisterDto | null;
    /**
     * 
     * @type {GetHealthcareFacilityDto}
     * @memberof GetRegisterNumberingDto
     */
    healthcareFacility?: GetHealthcareFacilityDto | null;
}

/**
 * Check if a given object implements the GetRegisterNumberingDto interface.
 */
export function instanceOfGetRegisterNumberingDto(value: object): value is GetRegisterNumberingDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetRegisterNumberingDtoFromJSON(json: any): GetRegisterNumberingDto {
    return GetRegisterNumberingDtoFromJSONTyped(json, false);
}

export function GetRegisterNumberingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRegisterNumberingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'symbolDoctor': json['symbolDoctor'] == null ? undefined : json['symbolDoctor'],
        'symbolPsychological': json['symbolPsychological'] == null ? undefined : json['symbolPsychological'],
        'activeFrom': json['activeFrom'] == null ? undefined : (new Date(json['activeFrom'])),
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'register': json['register'] == null ? undefined : GetRegisterDtoFromJSON(json['register']),
        'healthcareFacility': json['healthcareFacility'] == null ? undefined : GetHealthcareFacilityDtoFromJSON(json['healthcareFacility']),
    };
}

export function GetRegisterNumberingDtoToJSON(value?: GetRegisterNumberingDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'symbolDoctor': value['symbolDoctor'],
        'symbolPsychological': value['symbolPsychological'],
        'activeFrom': value['activeFrom'] == null ? undefined : ((value['activeFrom'] as any).toISOString()),
        'activeTo': value['activeTo'] == null ? undefined : ((value['activeTo'] as any).toISOString()),
        'register': GetRegisterDtoToJSON(value['register']),
        'healthcareFacility': GetHealthcareFacilityDtoToJSON(value['healthcareFacility']),
    };
}

